<div class="m-overlay"
     ref="baseWindow">
    <slot name="trigger" />
    <portal :target-el="portalTargetSelector"
            v-if="portalCreated">
        <transition name="m--is"
                    :duration="{ enter: 800, leave: 600 }">
            <div class="m-overlay__wrap"
                 :class="[{ 'm--is-disabled':disabled},
                            className ]"
                 ref="modalWrap"
                 v-show="propOpen"
                 v-if="portalMounted">
                <article class="m-overlay__article"
                         ref="article"
                         role="dialog"
                         :aria-labelledby="titleId"
                         tabindex="-1">
                    <header :id="titleId"
                            class="m-overlay__header"
                            :class="{'m--no-padding': !padding || !paddingHeader}">
                        <div class="m-overlay__header-left">
                            <slot name="header" />
                        </div>
                        <div class="m-overlay__header-right"
                             v-if="$slots['header-right']">
                            <slot name="header-right" />
                        </div>
                    </header>
                    <div ref="body"
                         class="m-overlay__body"
                         :class="{ 'm--no-padding': !padding || !paddingBody }">
                        <slot />
                    </div>
                    <footer v-if="!hideFooter"
                            class="m-overlay__footer"
                            ref="footer"
                            :class="{
                                'm--no-padding': !padding || !paddingFooter,
                             }">
                        <slot name="footer">
                            <m-button @click="save()"
                                      :disabled="isSaveButtonDisabled"
                                      :waiting="isWaiting"
                                      class="m-overlay__save-button">
                                {{ $i18n.translate('m-overlay:save') }}
                            </m-button>
                            <m-button @click="cancel()"
                                      skin="secondary"
                                      :disabled="isWaiting">
                                {{ $i18n.translate('m-overlay:cancel') }}
                            </m-button>
                        </slot>
                    </footer>
                </article>
            </div>
        </transition>
    </portal>
</div>
